<template>
  <v-layout column fill-height>
    <div :class="[isPrint ? 'print-only' : 'ma-5']">
      <v-data-table
        :items="semenByBreed.data"
        :headers="subheaders"
        :options.sync="options"
        :loading="semenByBreed.loading"
        :hide-default-footer="hideFooter"
        :disable-pagination="disablePagination"
        hide-default-header
      >
        <template #no-data>
          {{ $t('common.noData') }}
        </template>
        <template #header>
          <thead>
            <tr>
              <th v-for="head in headers" :key="head.value" :colspan="head.colspan">
                {{ head.text }}
              </th>
            </tr>
            <tr>
              <th v-for="subheader in subheaders" :key="subheader.value">
                {{ subheader.text }}
              </th>
            </tr>
          </thead>
        </template>
        <template #item="props">
          <tr>
            <td v-for="subheader of subheaders" :key="subheader.value">
              <template v-if="subheader.value === 'breed'">
                {{ props.item[subheader.value] || $t('common.unknown') }}
              </template>
              <template v-else>
                {{ props.item[subheader.value] }}
              </template>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </v-layout>
</template>

<script>
import { generateCsvData } from '@/Helpers/yearly-report.helper';
import i18n from '@/translations/i18n';

export default {
  props: {
    isPrint: { type: Boolean, default: true },
    disablePagination: { type: Boolean, default: true },
    hideFooter: { type: Boolean, default: true },
  },
  data: (data) => ({
    options: {
      page: 1,
      itemsPerPage: data.disablePagination ? -1 : 10,
    },
    semenByBreed: data.$store.state.yearlyReport.semenByBreed,
    headers: [
      { value: 'hengsten', text: i18n.t('reports.yearlyReports.spermSentReceived.stallion'), colspan: 2 },
      { value: 'fresh', text: i18n.t('reports.yearlyReports.spermSentReceived.fresh'), colspan: 2 },
      { value: 'frozen', text: i18n.t('reports.yearlyReports.spermSentReceived.frozen'), colspan: 2 },
    ],
    subheaders: [
      { value: 'breed', text: i18n.t('reports.yearlyReports.spermSentReceived.breed') },
      { value: 'horseCount', text: i18n.t('reports.yearlyReports.spermSentReceived.amountOfStallions') },
      { value: 'importFresh', text: i18n.t('reports.yearlyReports.spermSentReceived.freshIn') },
      { value: 'exportFresh', text: i18n.t('reports.yearlyReports.spermSentReceived.freshOut') },
      { value: 'importFrozen', text: i18n.t('reports.yearlyReports.spermSentReceived.frozenIn') },
      { value: 'exportFrozen', text: i18n.t('reports.yearlyReports.spermSentReceived.frozenOut') },
    ],
  }),
  computed: {
    year() {
      return this.$store.state.yearlyReport.year;
    },
  },
  watch: {
    year: {
      immediate: true,
      handler(newYear) {
        if (newYear) {
          this.fetchSemenImportExport();
        }
      },
    },
    'semenByBreed.data': {
      immediate: true,
      handler(newData) {
        const csvData = generateCsvData(this.headers, this.subheaders, newData);
        this.$emit('update-download-data', { dataUri: encodeURI(csvData), name: 'zendingen-sperma-per-ras.csv' });
      },
    },
  },
  methods: {
    async fetchSemenImportExport() {
      if (!this.semenByBreed.data.length || this.semenByBreed.year !== this.year) {
        this.$store.dispatch('yearlyReport/getSemenByBreed');
      }
    },
  },
};
</script>
